export const ValueType = {
  string: 'String',
  object: 'Object',
  array: 'Array',
  number: 'Number',
  date: 'Date',
  user: 'User',
  dept: 'Dept',
  dateRange: 'DateRange'
}

export const baseComponents = [
  // {
  //   name: '布局',
  //   components: [
  //     {
  //       title: '分栏布局',
  //       name: 'SpanLayout',
  //       icon: 'el-icon-c-scale-to-original',
  //       value: [],
  //       valueType: ValueType.array,
  //       props: {
  //         items:[]
  //       }
  //     }
  //   ]
  // },
   {
    name: '基础控件',
    components: [
      {
        title: '单行输入框',
        name: 'TextInput',
        icon: 'icon-danhang',
        value: '',
        valueType: ValueType.string,
        props: {
          required: false,
          enablePrint: true
        }
      },
      {
        title: '多行输入框',
        name: 'TextareaInput',
        icon: 'icon-duohang',
        value: '',
        valueType: ValueType.string,
        props: {
          required: false,
          enablePrint: true
        }
      },
      {
        title: '单选框',
        name: 'SelectInput',
        icon: 'icon-danxuan',
        value: '',
        valueType: ValueType.string,
        props: {
          required: false,
          enablePrint: true,
          expanding: false,
          options: ['选项1', '选项2']
        }
      },
      {
        title: '多选框',
        name: 'MultipleSelect',
        icon: 'icon-duoxuan',
        value: [],
        valueType: ValueType.array,
        props: {
          required: false,
          enablePrint: true,
          expanding: false,
          options: ['选项1', '选项2']
        }
      },
      {
        title: '数字输入框',
        name: 'NumberInput',
        icon: 'icon-shuzi',
        value: '',
        valueType: ValueType.number,
        props: {
          required: false,
          enablePrint: true,
        }
      },
      {
        title: '说明文字',
        name: 'Description',
        icon: 'icon-shuoming',
        value: '',
        valueType: ValueType.string,
        props: {
          required: false,
          showDetail: false,
          enablePrint: true
        }
      },
      {
        title: '日期',
        name: 'DateTime',
        icon: 'icon-riqi',
        value: '',
        valueType: ValueType.date,
        props: {
          required: false,
          enablePrint: true,
          format: 'yyyy-MM-dd',
        }
      },
      {
        title: '日期区间',
        name: 'DateTimeRange',
        icon: 'icon-riqiqujian',
        valueType: ValueType.dateRange,
        props: {
          required: false,
          enablePrint: true,
          placeholder: ['开始时间', '结束时间'],
          format: 'yyyy-MM-dd',
          totalType:'none',
          showLength: false
        }
      },
      {
        title: '图片上传',
        name: 'ImageUpload',
        icon: 'icon-tupian',
        value: [],
        valueType: ValueType.array,
        props: {
          required: false,
          enablePrint: true,
          maxSize: 5, //图片最大大小MB
          maxNumber: 1, //最大上传数量
          enableZip: true //图片压缩后再上传
        }
      },
      {
        title: '电话',
        name: 'PhoneInput',
        icon: 'icon-dianhua',
        value: '',
        valueType: ValueType.object,
        props: {
          required: false,
          enablePrint: true,
          inputType:'phone',
        }
      },
    ]
  }, {
    name: '增强控件',
    components: [
      {
        title: '附件上传',
        name: 'FileUpload',
        icon: 'icon-fujian',
        value: [],
        valueType: ValueType.array,
        props: {
          required: false,
          enablePrint: true,
          onlyRead: false, //是否只读，false只能在线预览，true可以下载
          maxSize: 100, //文件最大大小MB
          maxNumber: 20, //附件默认支持20个，避免旧版单附件限制
          fileTypes: [] //限制文件上传类型
        }
      },
      {
        title: '部门',
        name: 'DeptPicker',
        icon: 'icon-bumen',
        value: [],
        valueType: ValueType.dept,
        props: {
          required: false,
          enablePrint: true,
          multiple: false
        }
      },
      {
        title: '金额',
        name: 'AmountInput',
        icon: 'icon-jine',
        value: '',
        valueType: ValueType.number,
        props: {
          required: false,
          enablePrint: true,
          showChinese: true
        }
      },
      {
        title: '省市区',
        name: 'AreaPicker',
        icon: 'icon-shengshiqu',
        value: '',
        valueType: ValueType.object,
        props: {
          required: false,
          enablePrint: true,
          multiple: false,
          inputType:'city'
        }
      },
      {
        title: '选择人员',
        name: 'UserPicker',
        icon: 'icon-person',
        value: [],
        valueType: ValueType.user,
        props: {
          required: false,
          enablePrint: true,
          multiple: false
        }
      },
      {
        title: '入职日期',
        name: 'JoinDate',
        icon: 'icon-ruzhi',
        value: '',
        valueType: ValueType.string,
        props: {
          required: false,
          enablePrint: true,
        }
      },
      // {
      //   title: '人员选择',
      //   name: 'UserPicker',
      //   icon: 'el-icon-user',
      //   value: [],
      //   valueType: ValueType.user,
      //   props: {
      //     required: false,
      //     enablePrint: true,
      //     multiple: false
      //   }
      // },
      // {
      //   title: '明细表',
      //   name: 'TableList',
      //   icon: 'el-icon-tickets',
      //   value: [],
      //   valueType: ValueType.array,
      //   props: {
      //     required: false,
      //     enablePrint: true,
      //     showBorder: true,
      //     rowLayout: true,
      //     showSummary: false,
      //     summaryColumns: [],
      //     maxSize: 0, //最大条数，为0则不限制
      //     columns:[] //列设置
      //   }
      // }, 
      // {
      //   title: '办公物资表',
      //   name: 'PurchaseGoodsList',
      //   icon: 'el-icon-s-grid',
      //   id: 'PurchaseGoodsList',
      //   value: [],
      //   valueType: ValueType.array,
      //   props: {
      //     required: false,
      //     enablePrint: true,
      //     rowLayout: true
      //   }
      // }
    ]
  }
]



export default {
  baseComponents
}

